
import Vue from 'vue'
import { isEmailValid } from '@/services/EmailHelpers'
import { ContactUsDto } from '@ViewModels/ContactUsDto'
import { Alert } from '@/components'
import { SaveButton } from '@/components/buttons'
import { Textbox, Emailbox, TextArea, RadioGroup } from '@/components/formGroups'

export default Vue.extend({
   name: 'EmailAddressSection',
   props: {
      data: { required: true, type: Object as () => ContactUsDto },
      processing: { type: Boolean, default: false },
   },
   data() {
      return {
         submitted: false,
         reasonOptions: [
            { name: 'Question', value: 'Question' },
            { name: 'Suggestion', value: 'Suggestion' },
            { name: 'Something is broken', value: 'Broken' },
         ] as NameValuePair[],
      }
   },
   computed: {
      validationMessages(): string[] {
         const messages: string[] = []
         if (!this.data.Email) {
            messages.push('Email Address is missing')
         }
         if (!!this.data.Email && !isEmailValid(this.data.Email)) {
            messages.push('Email Address is not valid')
         }
         if (!this.data.Message) {
            messages.push('Message is missing')
         }
         return messages
      },
      isValid(): boolean {
         return this.validationMessages.length === 0
      },
      allowSubmission(): boolean {
         return !this.submitted || this.isValid
      },
      showValidationError(): boolean {
         return !this.isValid && this.submitted
      },
   },
   methods: {
      submit() {
         this.submitted = true
         if (this.isValid) {
            this.$emit('click')
         }
      },
   },
   components: {
      Alert,
      Textbox,
      SaveButton,
      Emailbox,
      TextArea,
      RadioGroup,
   },
})
